import React, { useEffect, useState } from "react";
import { useTranslate } from "@obsbot/remo-i18n";
import { filterInputValueForNumber } from "@obsbot/remo-utils";
import { InputWithCode } from "../../InputWithCode";
import { withMessage } from "../../../HOC/withMessage";
import "./index.less";
import { verifyCodeVal } from "@obsbot/remo-server-api";
import { v4 as uuidV4 } from "uuid";

export interface ForgotPwdContentProps {
    visible: boolean;
    account?: string;
    isCodeError: boolean;
    onGetCode: () => Promise<boolean>;
    onNext: (code: string) => void;
    setIsCodeError: (flag: boolean) => void;
    setVisible: (flag: boolean) => void;
}

export const ForgotPwdContent: React.FC<ForgotPwdContentProps> = withMessage(
    ({ visible, account, isCodeError, setIsCodeError, setVisible, onGetCode, onNext, message }) => {
        const t = useTranslate();
        console.log("visible", visible);
        // 验证码input
        const [code, setCode] = useState("");
        // 重置
        useEffect(() => {
            setCode("");
        }, [visible]);
        const handleOnNext = async (): Promise<void> => {
            if (!code || !account) {
                message.warning(t("noInputSingle", { text1: t("verifyCode") }));
                return;
            }
            if (code.length < 6) {
                message.warning(t("forgotPwd.atLeastSix"));
                return;
            }
            const res = await verifyCodeVal({
                account,
                msg_type: "forget_pwd",
                client_type: (window as any).isElectron ? "game_client" : "web",
                verification_code: code,
                force_flag: 0,
                mobile_id: uuidV4(),
            });
            if (res) {
                onNext && onNext(code);
            }
        };
        return (
            <div className="ForgotPwdContent">
                <div className="header">{t("forgotPwd.title")}</div>
                <div className="forgot-modal-warn-text">
                    {t("forgotPwd.description", { account: account })}
                </div>
                <div className="forgot-modal-code">
                    <div className="forgot-modal-code-title">{t("verifyCode")}</div>
                    <InputWithCode
                        alreadySending={visible}
                        className="forgot-modal-code-input"
                        code={code}
                        errorMsg={t("verifyFailed")}
                        isCodeError={isCodeError}
                        maxLength={6}
                        placeholder={t("verifyCodePlaceholder")}
                        setCode={setCode}
                        t={t}
                        value={code}
                        onChange={(e: any) => {
                            setCode(filterInputValueForNumber(e.target.value));
                            setIsCodeError && setIsCodeError(false);
                        }}
                        onFocus={() => setIsCodeError && setIsCodeError(false)}
                        onGetCode={onGetCode}
                        onKeyDown={(e: any) => {
                            if (e.key === "Enter") {
                                handleOnNext();
                            }
                        }}
                    />
                </div>
                <div className="forgot-modal-button-group">
                    <div
                        className="normal-button"
                        onClick={() => {
                            setCode("");
                            setVisible && setVisible(false);
                        }}
                    >
                        {t("forgotPwd.cancel")}
                    </div>
                    <div
                        className={"forgot-modal-button-item"}
                        data-disabled={code.length !== 6}
                        onClick={() => code.length === 6 && handleOnNext()}
                    >
                        {t("forgotPwd.confirm")}
                    </div>
                </div>
            </div>
        );
    },
);
